import { Flex, Text, Button } from "@chakra-ui/react";
import { BsFillCameraFill } from "react-icons/bs";
import { useState, useRef } from "react";
import { AiOutlineCloseCircle } from "react-icons/ai";
import { VisualizarFoto } from "./VisualizarFoto";
import WebcamInput from "./WebcamInput";
import { Loading } from "./Loading";
import { useEffect } from "react";

export const InserirImagens = ({
  setFoto1,
  setFoto2,
  setFoto3,
  foto1,
  foto2,
  foto3,
}) => {
  const [webCamOpen1, setWebCamOpen1] = useState(false);
  const [webCamOpen2, setWebCamOpen2] = useState(false);
  const [webCamOpen3, setWebCamOpen3] = useState(false);

  const [visualizarFoto, setVisualizarFoto] = useState(false);

  const [showFoto1, setShowFoto1] = useState(false);
  const [showFoto2, setShowFoto2] = useState(false);
  const [showFoto3, setShowFoto3] = useState(false);

  const [loading, setLoading] = useState(false);

  const webcamRef = useRef(null);

  const openWebCam = (webCam) => {
    try {
      if (webCam === 1) {
        setWebCamOpen1(true);
      } else if (webCam === 2) {
        setWebCamOpen2(true);
      } else if (webCam === 3) {
        setWebCamOpen3(true);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const closeWebCam = (webCam) => {
    if (webCam === 1) {
      setWebCamOpen1(false);
    } else if (webCam === 2) {
      setWebCamOpen2(false);
    } else if (webCam === 3) {
      setWebCamOpen3(false);
    }
  };

  const showFotos = (foto) => {
    setVisualizarFoto(true);
    if (foto === 1) {
      setShowFoto1(true);
    }
    if (foto === 2) {
      setShowFoto2(true);
    }
    if (foto === 3) {
      setShowFoto3(true);
    }
  };

  const capture = (webCam) => {
    const imageSrc = webcamRef.current.getScreenshot();
    if (webCam === 1) {
      setFoto1(imageSrc);
      setWebCamOpen1(false);
    } else if (webCam === 2) {
      setFoto2(imageSrc);
      setWebCamOpen2(false);
    } else if (webCam === 3) {
      setFoto3(imageSrc);
      setWebCamOpen3(false);
    }
  };

  const removeFoto = (webCam) => {
    if (webCam === 1) {
      setFoto1(null);
    } else if (webCam === 2) {
      setFoto2(null);
    } else if (webCam === 3) {
      setFoto3(null);
    }
  };

  return (
    <>
      {loading && <Loading />}
      {webCamOpen1 && (
        <WebcamInput
          webCam={1}
          closeWebCam={() => closeWebCam(1)}
          capture={() => capture(1)}
          ref={webcamRef}
          webCamOpen={webCamOpen1}
        />
      )}

      {webCamOpen2 && (
        <WebcamInput
          webCam={2}
          closeWebCam={() => closeWebCam(2)}
          capture={() => capture(2)}
          ref={webcamRef}
          webCamOpen={webCamOpen2}
        />
      )}

      {webCamOpen3 && (
        <WebcamInput
          webCam={3}
          closeWebCam={() => closeWebCam(3)}
          capture={() => capture(3)}
          ref={webcamRef}
          webCamOpen={webCamOpen3}
        />
      )}
      <Flex mt={2} align="center" justify="start" gap={2}>
        <Text paddingBlock={2} paddingInline={4} color="black">
          Inserir imagens
        </Text>

        <Flex
          align="center"
          height="100%"
          bg="white"
          color="#378BBF"
          ml={2}
          cursor="pointer"
        >
          <Flex
            align="end"
            flexDir="column"
            justify="center"
            position="relative"
          >
            <Flex align="center" gap={2}>
              {!foto1 ? (
                <Button
                  bg={foto1 ? "#378BBF" : "gray.100"}
                  color={foto1 ? "white" : "#378BBF"}
                  _hover={{ filter: "brightness(0.9)" }}
                  height="2rem"
                  transition="filter 0.2s"
                  onClick={() => openWebCam(1)}
                >
                  <BsFillCameraFill size={20} />
                  <Text fontSize={[".8rem"]} ml={2}>
                    Anexar foto 1
                  </Text>
                </Button>
              ) : (
                <>
                  <Button
                    bg={foto1 ? "#378BBF" : "gray.100"}
                    color={foto1 ? "white" : "#378BBF"}
                    _hover={{ filter: "brightness(0.9)" }}
                    height="2rem"
                    transition="filter 0.2s"
                    onClick={() => showFotos(1)}
                  >
                    <BsFillCameraFill size={20} />
                    <Text fontSize={[".8rem"]} ml={2}>
                      Visualizar foto 1
                    </Text>
                  </Button>
                </>
              )}
            </Flex>
            {!!foto1 && (
              <Flex
                position="absolute"
                bottom="-1.4rem"
                right="0"
                align="center"
                gap={2}
                onClick={() => removeFoto(1)}
              >
                <Text fontSize={[".8rem"]} ml={2}>
                  Excluir foto
                </Text>
                <AiOutlineCloseCircle size={20} />
              </Flex>
            )}
          </Flex>
        </Flex>
        <Flex
          align="center"
          height="100%"
          bg="white"
          color="#378BBF"
          ml={2}
          cursor="pointer"
        >
          <Flex
            align="end"
            flexDir="column"
            justify="center"
            position="relative"
          >
            <Flex align="center" gap={2}>
              {!foto2 ? (
                <Button
                  bg={foto2 ? "#378BBF" : "gray.100"}
                  color={foto2 ? "white" : "#378BBF"}
                  _hover={{ filter: "brightness(0.9)" }}
                  height="2rem"
                  transition="filter 0.2s"
                  onClick={() => openWebCam(2)}
                >
                  <BsFillCameraFill size={20} />
                  <Text fontSize={[".8rem"]} ml={2}>
                    Anexar foto 2
                  </Text>
                </Button>
              ) : (
                <>
                  <Button
                    bg={foto2 ? "#378BBF" : "gray.100"}
                    color={foto2 ? "white" : "#378BBF"}
                    _hover={{ filter: "brightness(0.9)" }}
                    height="2rem"
                    transition="filter 0.2s"
                    onClick={() => showFotos(2)}
                  >
                    <BsFillCameraFill size={20} />
                    <Text fontSize={[".8rem"]} ml={2}>
                      Visualizar foto 2
                    </Text>
                  </Button>
                </>
              )}
            </Flex>
            {!!foto2 && (
              <Flex
                position="absolute"
                bottom="-1.4rem"
                right="0"
                align="center"
                gap={2}
                onClick={() => removeFoto(2)}
              >
                <Text fontSize={[".8rem"]} ml={2}>
                  Excluir foto
                </Text>
                <AiOutlineCloseCircle size={20} />
              </Flex>
            )}
          </Flex>
        </Flex>
        <Flex
          align="center"
          height="100%"
          bg="white"
          color="#378BBF"
          ml={2}
          cursor="pointer"
        >
          <Flex
            align="end"
            flexDir="column"
            justify="center"
            position="relative"
          >
            <Flex align="center" gap={2}>
              {!foto3 ? (
                <Button
                  bg={foto3 ? "#378BBF" : "gray.100"}
                  color={foto3 ? "white" : "#378BBF"}
                  _hover={{ filter: "brightness(0.9)" }}
                  height="2rem"
                  transition="filter 0.2s"
                  onClick={() => openWebCam(3)}
                >
                  <BsFillCameraFill size={20} />
                  <Text fontSize={[".8rem"]} ml={2}>
                    Anexar foto 3
                  </Text>
                </Button>
              ) : (
                <>
                  <Button
                    bg={foto3 ? "#378BBF" : "gray.100"}
                    color={foto3 ? "white" : "#378BBF"}
                    _hover={{ filter: "brightness(0.9)" }}
                    height="2rem"
                    transition="filter 0.2s"
                    onClick={() => showFotos(3)}
                  >
                    <BsFillCameraFill size={20} />
                    <Text fontSize={[".8rem"]} ml={2}>
                      Visualizar foto 3
                    </Text>
                  </Button>
                </>
              )}
            </Flex>
            {!!foto3 && (
              <Flex
                position="absolute"
                bottom="-1.4rem"
                right="0"
                align="center"
                gap={2}
                onClick={() => removeFoto(3)}
              >
                <Text fontSize={[".8rem"]} ml={2}>
                  Excluir foto
                </Text>
                <AiOutlineCloseCircle size={20} />
              </Flex>
            )}
          </Flex>
        </Flex>
      </Flex>

      {showFoto1 && (
        <VisualizarFoto
          foto={foto1}
          onClose={setShowFoto1}
          visualizarFoto={visualizarFoto}
        />
      )}
      {showFoto2 && (
        <VisualizarFoto
          foto={foto2}
          onClose={setShowFoto2}
          visualizarFoto={visualizarFoto}
        />
      )}
      {showFoto3 && (
        <VisualizarFoto
          foto={foto3}
          onClose={setShowFoto3}
          visualizarFoto={visualizarFoto}
        />
      )}
    </>
  );
};
